var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('v-pannellum',{style:(_vm.style),attrs:{"showFullscreen":true,"mouseZoom":false,"doubleClickZoom":true,"orientation":true,"hfov":100,"yaw":-90,"pitch":0,"autoRotate":true,"src":_vm.equirectangularUrl}}),_c('SectionLayout',{staticStyle:{"z-index":"1"}},[_c('Nav'),_c('SectionHero')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }